export default __webpack_public_path__ + "static/media/dark-logo.6e8e9bfb.svg";